export const RELATION_TYPES_RESOURCE = 'relationTypes';
export const RELATION_TYPE_RESOURCE = 'relationType';
export const CREATE_RELATION_TYPE_RESOURCE = 'createRelationType';
export const UPDATE_RELATION_TYPE_RESOURCE = 'updateRelationType';
export const REMOVE_RELATION_TYPE_RESOURCE = 'removeRelationType';

export const INFINITE_SCROLL = { loader: 'blocked' };

export const ACTIONS = {
  NEW: 'new',
  EDIT: 'edit',
};

export const SORTED = { defaults: { column: 'name', direction: 'ascending' } };
